export interface Screenshot {
  /** File name under /screenshots/{desktop,phone}/ and the path shown in the browser frame. */
  id: string
  label: string
  title: string
  caption: string
  alt: string
}

// Captured from a seeded demo household by the marketing capture script, at 1440×900 @2× and 390×844 @3×.
export const SCREENSHOTS: Screenshot[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    title: 'Your month at a glance',
    caption: 'Net worth, what came in, what went out, and which budgets need a look.',
    alt: 'Dashboard showing net worth, this month’s savings rate, spending by category and daily spending',
  },
  {
    id: 'transactions',
    label: 'Transactions',
    title: 'Every transaction, findable',
    caption:
      'Search and filter by month, type or account. Splits, refunds and transfers stay tidy.',
    alt: 'Transactions page with the month’s net, a daily chart and a list of expenses',
  },
  {
    id: 'accounts',
    label: 'Accounts',
    title: 'Every account in one place',
    caption:
      'Checking, savings, cards, investments and loans — plus what’s actually ready to spend.',
    alt: 'Accounts page listing bank accounts, cash and investments beside loans and credit cards',
  },
  {
    id: 'budget',
    label: 'Budget',
    title: 'Budgets that keep pace',
    caption: 'Monthly and yearly limits per category, with what’s left to spend each day.',
    alt: 'Budget page with money left to spend this month and progress bars for each category',
  },
  {
    id: 'goals',
    label: 'Goals',
    title: 'Goals that know their pace',
    caption: 'Set money aside inside any account and see at a glance if you’re on track.',
    alt: 'Goals page with a Japan trip, a car fund and an emergency fund, each with an on-track badge',
  },
  {
    id: 'recurring',
    label: 'Recurring',
    title: 'Bills before they’re due',
    caption: 'Subscriptions, bills and loan payments, with everything due this week up front.',
    alt: 'Recurring page with monthly commitments and the bills due this week',
  },
  {
    id: 'people',
    label: 'People',
    title: 'Who owes whom',
    caption: 'Split a dinner, lend some cash, settle up later. Balances keep themselves.',
    alt: 'People page showing how much each friend owes you or you owe them',
  },
  {
    id: 'loans',
    label: 'Loans',
    title: 'Loans, paid down',
    caption: 'What’s left to pay, monthly payments, prepayments and the interest so far.',
    alt: 'Loans page with a mortgage and a car loan, principal repaid and interest paid',
  },
  {
    id: 'analytics',
    label: 'Analytics',
    title: 'Insights that add up',
    caption: 'Savings rate, runway, and how this month compares with your usual.',
    alt: 'Analytics overview with amount saved, spending versus usual and months of runway',
  },
  {
    id: 'categories',
    label: 'Categories',
    title: 'Where it all goes',
    caption: 'Spending by category, and what grew or shrank since last month.',
    alt: 'Categories page breaking down the month’s spending by category against last month',
  },
  {
    id: 'calendar',
    label: 'Calendar',
    title: 'Your money, day by day',
    caption: 'Every day’s spending and income laid out on a calendar.',
    alt: 'Calendar of the month with each day’s income and expenses',
  },
]
